import React from 'react';
import { Button } from '../../Components/Button';
import { FullScreenModalButtonContainer } from '../../Components/FullScreenModal';
import { UpdateMedicationListStep } from './MedicationListDialogBulkActionWizard';
export var MedicationListBulkActionButtons = function (props) {
    var formProps = props.formProps;
    if (props.step === UpdateMedicationListStep.Error)
        return (React.createElement(Button, { key: 'Cancel', width: 168, type: 'button', testId: 'navigation-control-close', onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                props.onClose();
            } }, "Cancel"));
    return (React.createElement(FullScreenModalButtonContainer, null,
        React.createElement(Button, { key: 'continue', width: 168, type: 'button', disabled: formProps.isSubmitting, testId: 'navigation-control-Continue', onClick: props.onContinue }, "Continue")));
};
